<script>
	// Stores 
	import { textSite, linkWhatsappCondominio, linkAV, linkConheca, mailProposta } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader	from "../components/PageHeader.svelte";

   	// Code	
	let titlePage = 'Administração de Condomínios ';

</script>

<PageHeader title={titlePage}></PageHeader>

<div class="container">

	<p>Seu condomínio administrado de forma profissional e competente, confira os benefícios.</p>
	<hr>

	<div class="box-itens-icon">
		<div class="item">
			<div class="icone">
				<i class="fas fa-calculator-alt fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Condomínio Efetivo</h3>
				<p>A Zimmer paga as despesas do mês do condomínio, e rateia somente no final do mês o valor gasto (condomínio efetivo), não gera saldo positivo nem negativo no condomínio (*).</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-usd-circle fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Valor fixo de Condomínio</h3>
				<p>Os condôminos decidem o valor do condomínio em assembléia sendo que todas as despesas que excederem a previsão orçamentária serão pagas pela administradora para futuro ressarcimento quando da realização da próxima previsão orçamentária (*).</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-comments-dollar fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Chamadas Extras</h3>
				<p>Negociação com cada condômino sobre qual a melhor data para pagamento das despesas extraordinárias, não onerando o orçamento doméstico com despesas imprevistas.</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-portrait fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Aposentados</h3>
				<p>Pagamento do condomínio somente no dia do recebimento da aposentadoria, (este item terá que ser necessariamente aprovado em assembléia).</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-file-invoice-dollar fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Pagamento de Docs</h3>
				<p>Pagamento em toda rede bancária, remessa de docs para qualquer endereço, em qualquer local do Brasil, Europa, EUA Japão. Emissão de docs com os valores separados das despesas extraordinárias e despesas ordinárias.</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-money-check-alt fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Recebimento Fácil</h3>
				<p>Você pode negociar através de pré-programação de cheques qual o melhor dia para pagamento do condomínio evitando transtornos.</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-dog fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Canil</h3>
				<p>Mantemos convênios com canis, que concederão descontos para hospedagem e tratamento de animais, quando da necessidade de viagem ou problemas de saúde.</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-flower-daffodil fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Estufa</h3>
				<p>Mantemos convênio com floricultura, que concederão descontos, para manter suas plantas em estufa climatizada enquanto você tira férias.</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-vacuum fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Recibos de Empregados Domésticos</h3>
				<p>Realizamos a emissão de recibos de salário para todos os empregados domésticos que trabalham nos apartamentos do edifício e orientação jurídica para rescisões trabalhistas (*).</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-umbrella-beach fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Viagem Tranquila</h3>
				<p>Buscamos em seu edifício e realizamos pagamentos pré-programados de todas as suas contas enquanto você tira férias.</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-shield-check fa-5x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Dicas de Segurança</h3>
				<p>Uma equipe especialmente treinada visitará o edifício e fará o levantamento apontado as áreas de riscos de segurança do condomínio.</p>
			</div>
		</div>
	</div>
	<br />
	<p>Obs.: * Taxa de serviço conforme tabela na imobiliária.</p>
	<br />
	<p>Em caso de dúvidas, entre em <a href="/solicite-proposta">contato</a> conosco, nossa equipe está à disposição para auxiliar. Solicite uma proposta, sem compromisso.</p>
	<div class="button text-center mt-40">
		<a href="/solicite-proposta" use:link replace title="Solicite uma Proposta" class="btn btn-primary">Solicite uma Proposta <i class="far fa-arrow-right"></i></a>
	</div>
	<br />	

</div>